 <svg
        class="animated-svg library"
        [attr.viewBox]="'0 0 ' + 500 + ' ' + (height() + 150)"
        preserveAspectRatio="xMidYMin meet">
        
        <g shadow-type-3 [height]="height()"/>
        <g wall-type-1 [height]="height()"></g>
        
        <g roof-type-1/>
        <g window-type-7 [height]="height()"/>
        <g foundation-type-3 [height]="height()"/>
        <g outline />

    </svg>